'use client';

import { useMemo } from 'react';
import { usePathname } from 'next/navigation';
import { RouteMeta } from '../../../../_components/page/RouteMeta';
import { deriveQuoteActiveTabFromPathname } from '../../../../../src/utils/quote/active-tab';
import { buildQuotePageTargeting } from '../../../../../src/utils/quote/page-targeting';
import type { ActiveTab } from '../../../../../src/utils/quote/types';

interface QuoteTabAdTargetingProps {
  isZacksApplied: boolean;
  symbol: string;
  quoteTitlesByTab: Partial<Record<ActiveTab, string>>;
}

export default function QuoteTabAdTargeting({ isZacksApplied, symbol, quoteTitlesByTab }: QuoteTabAdTargetingProps) {
  const pathname = usePathname();
  const activeTab = deriveQuoteActiveTabFromPathname(pathname);
  const targeting = useMemo(
    () => buildQuotePageTargeting(symbol, activeTab, { isZacksApplied }),
    [symbol, activeTab, isZacksApplied],
  );
  return <RouteMeta pageTargeting={targeting} quoteTitlesByTab={quoteTitlesByTab} />;
}
